import { render } from "./DashboardAmministratori.vue?vue&type=template&id=f5003196&scoped=true"
import script from "./DashboardAmministratori.vue?vue&type=script&lang=js"
export * from "./DashboardAmministratori.vue?vue&type=script&lang=js"

import "./DashboardAmministratori.vue?vue&type=style&index=0&id=f5003196&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5003196"]])

export default __exports__